import classNames from 'classnames';
import React, { useMemo } from 'react';
import styles from './balance.module.scss';
import { formatPrice } from '../../helpers/formatter';
import { useTradingAccount } from '../../contexts/TradingAccountContext';
import { Tooltip } from '@mui/material';
import { useDeviceContext } from '@/contexts/DeviceContext';
import { useNavbarStyles } from '../../hooks/useNavbarStyles';
import { useSettings } from '@contexts/SettingsContext';
import { TradingPlatforms, config } from '@/config';

type AvailableCashProps = {
  padding?: number;
  fontSize?: number;
  variant?: 'default' | 'dark';
};

const AvailableCashInfo: React.FC<AvailableCashProps> = (props: AvailableCashProps): JSX.Element => {
  const { isMobile } = useDeviceContext();
  const { activeTradingAccount } = useTradingAccount();
  const { customSettings } = useSettings();
  const { renderFontSize, backgroundColor } = useNavbarStyles(props.variant);

  // Only render if config is TopstepIB
  if (config.platform != TradingPlatforms.TopstepIB) {
    return null;
  }

  return useMemo(
    () => (
      <div className={classNames(isMobile ? styles.balanceMobile : styles.balance)} style={{ padding: props.padding, backgroundColor: backgroundColor }}>
          <div className={styles.balanceAmount} style={{ fontSize: props.fontSize ?? renderFontSize }}>
            <span>PURCHASING POWER: </span>
            <span>${formatPrice(activeTradingAccount.availableCash)}</span>
          </div>
      </div>
    ),
    [isMobile, activeTradingAccount?.availableCash, customSettings.topNavTextSize]
  );
};

export default React.memo(AvailableCashInfo);
